"use client";

import { Suspense } from "react";
import Script from "next/script";
import { ThemeProvider } from "@/packages/context/ThemeContext";
import { AuthContextProvider } from "@/packages/context/AuthContext";
import { GeneralSettingsProvider } from "@/packages/context/GeneralSettingContext";
import { CurrencyProvider } from "@/packages/context/CurrencyContext";
import { CountryProvider } from "@/packages/context/CountryContext";
import { CartProvider } from "@/packages/context/CartContext";
import { WishlistProvider } from "@/packages/context/wishlistContext";
import HeaderWrapper from "@/components/header/HeaderWrapper";
import FooterV2 from "@/components/footer/FooterV2";
import HomeBar from "@/components/common/HomeBar";
import HealthGate from "@/components/common/HealthGate";
import FloatingWhatsApp from "@/components/common/FloatingWhatsApp";
import SiteSourceTracker from "@/components/common/SiteSourceTracker";


export default function LayoutWrapper({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <>
      <Script src="https://js.stripe.com/v3/" strategy="beforeInteractive" />
      <SiteSourceTracker />
      <HealthGate>

        <ThemeProvider>
          <AuthContextProvider>
            <GeneralSettingsProvider>
              <CurrencyProvider>
                <CountryProvider>
                  <CartProvider>
                    <WishlistProvider>
                      <div className="min-h-screen flex flex-col w-full">
                        <Suspense fallback={<div className="h-16" />}>
                          <HeaderWrapper />
                        </Suspense>

                        <main className="flex-1 w-full">{children}</main>

                        <FooterV2 />
                      </div>

                      <Suspense fallback={null}>
                        <HomeBar />
                      </Suspense>

                      <FloatingWhatsApp />
                    </WishlistProvider>
                  </CartProvider>
                </CountryProvider>
              </CurrencyProvider>
            </GeneralSettingsProvider>
          </AuthContextProvider>
        </ThemeProvider>
      </HealthGate>
    </>
  );
}


